export const API_BASE = "https://rickandmortyapi.com/api";

/** `.../api/character/42` → `42`. Returns null for anything unexpected. */
export function characterIdFromUrl(url: string): number | null {
  const id = Number(url.split("/").pop());
  return Number.isFinite(id) && id > 0 ? id : null;
}

/**
 * The API serves every avatar at a predictable path, so a thumbnail can be
 * built from the ids an episode already carries — no extra request per card.
 */
export function avatarUrl(characterId: number): string {
  return `${API_BASE}/character/avatar/${characterId}.jpeg`;
}

export function characterIds(urls: string[], limit?: number): number[] {
  const ids = urls
    .map(characterIdFromUrl)
    .filter((id): id is number => id !== null);
  return limit === undefined ? ids : ids.slice(0, limit);
}

/** The API takes a comma-separated id list, so N characters cost one request. */
export function charactersUrl(ids: number[]): string {
  return `${API_BASE}/character/${ids.join(",")}`;
}
